export default "__VITE_ASSET__BkKP$LY9__"